<template>
  <div>
    <iframe
      style="width: 100%; height: 100vh; margin: 0; padding: 0; border: none;"
      src="https://inter.sm-center.ru/#/dom-24"
    />
  </div>
</template>

<script>
export default {
  name: 'AccessGuide',
}
</script>

<style
  lang="scss"
  scoped
>
.empty__container {
  max-width: inherit !important;
  padding-inline: inherit !important;
}
</style>